<template>
  <div>
    <h2 v-if="$userIsTalent">My Activity</h2>
    <h2 v-else>{{ $starLabel }} Activity
    </h2>
    <div class="row">
        <metric-card
          v-for="stat in statList" :key="stat.name"
          :metric="stat"
          :style-options="'col-sm-4'"
        />
      <div class="col-sm-4" v-if="$userIsAdmin && showAll && $vlastMode">
        <label>Filter stats by {{ $t('Category') }}</label>
        <selectize
        key="category"
        class="selectize selectize-single"
        name="category_id"
        v-model="category_id"
        :options="categoryOptions"
        />
      </div>
    </div>
    <div class="row">
      <a @click="toggleShowAll" class="pull-right" style="cursor: pointer; padding: 0px 20px 20px 20px; display: inline-flex; align-items: center;">
        <i class="fa fa-2x fa-caret-up" v-if="showAll"/><span v-if="showAll">&nbsp; Show Less</span>
        <i class="fa fa-2x fa-caret-down" v-if="!showAll"/><span v-if="!showAll">&nbsp; Show More</span>
      </a>
    </div>
  </div>
</template>

<script>
import MetricCard from '../bi/MetricCard'
import Selectize from '../ext/codium/CodiumSelectize'
import { mapActions } from 'vuex'
import { map } from 'lodash'

export default {
  components: {
    MetricCard,
    Selectize
  },
  props: {
    stats: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      showAll: false,
      category_id: null,
      categoryOptions: []
    }
  },

  created () {
    this.getCategories().then(({ data }) => {
      this.categoryOptions = this.mapCategoryResponseForSelectize(data)
    })
  },

  methods: {
    ...mapActions('category', ['getCategories']),
    ...mapActions('user', ['getUser', 'resetUser']),

    toggleShowAll () {
      this.showAll = !this.showAll
    },

    /**
     * Map category response for selectize.
     *
     * @return array
     */
    mapCategoryResponseForSelectize (categories) {
      return map(categories, (category) => ({ id: category.id, text: category.name }))
    }
  },

  computed: {
    statList () {
      if (!this.stats) {
        return []
      }
      if (this.showAll) {
        return this.stats
      } else {
        return Object.entries(this.stats).slice(0, 3).map(stat => stat[1])
      }
    }
  }
}
</script>
